export const trendBundle = {
  title: {
    today: {
      ko: "실시간 사용 패턴",
      en: "Real-time Usage Pattern",
      es: "Patron de uso en tiempo real"
    },
    trend: { ko: "주요 사용량 추세", en: "Major Usage Trend", es: "Tendencia principal de uso" }
  },
  usage: { ko: "사용량", en: "Usage", es: "Uso" },
  minUsage: { ko: "최저 사용량", en: "Min", es: "Min" },
  maxUsage: { ko: "최고 사용량", en: "Max", es: "Max" }
}
